module.exports = __webpack_public_path__ + "img/hand.d6dde749.png";